import { render, staticRenderFns } from "./ProductCollectionForm.vue?vue&type=template&id=2b6da812"
import script from "./ProductCollectionForm.vue?vue&type=script&lang=js"
export * from "./ProductCollectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports